import $ from "jquery";

export const setup = (element, appRouter) => {
  element.on("click", "a[href]:not([data-bypass])", function (event) {
    if (event.isDefaultPrevented()) {
      return;
    }

    // Get the absolute anchor href.
    const href = { prop: $(this).prop("href"), attr: $(this).attr("href") };
    // Get the absolute root.
    const root = window.location.protocol + "//" + window.location.host;

    // Ensure the root is part of the anchor href, meaning it's relative.
    if (href.prop.slice(0, root.length) === root) {
      // Stop the default event to ensure the link will not cause a page
      // refresh.
      event.preventDefault();
      event.stopPropagation();

      // Route internal links through the app router so the page updates
      // without a full browser refresh.
      appRouter.navigate(href.attr, { trigger: true });
    }
  });
};
